export { downloadBlobFile } from "../../../utils/download";

export const createEmptyBREContact = () => ({
  name: "",
  company: null,
  job_title: "",
  email: "",
  direct_phone_number: "",
  cell_phone_number: "",
  linkedin: "",
  city: "",
  state: "",
  country: "",
  notes: "",
});

export const hydrateBREContactForm = (data = {}) => {
  const resolvedLocation = {
    city: data.city || data.company?.city || "",
    state: data.state || data.company?.state || "",
    country: data.country || data.company?.country || "",
  };

  return {
    ...createEmptyBREContact(),
    name: data.name ?? "",
    company: data.company
      ? {
          id: data.company.id,
          name: data.company.name,
          city: data.company.city,
          state: data.company.state,
          country: data.company.country,
          source: "bre",
        }
      : null,
    job_title: data.job_title ?? "",
    email: data.email ?? "",
    direct_phone_number: data.direct_phone_number ?? "",
    cell_phone_number: data.cell_phone_number ?? "",
    linkedin: data.linkedin ?? "",
    city: resolvedLocation.city,
    state: resolvedLocation.state,
    country: resolvedLocation.country,
    notes: data.notes ?? "",
  };
};

export const buildBREContactPayload = (contact) => ({
  name: contact.name || null,
  email: contact.email || null,
  direct_phone_number: contact.direct_phone_number || null,
  cell_phone_number: contact.cell_phone_number || null,
  job_title: contact.job_title || null,
  linkedin: contact.linkedin || null,
  company_id: contact.company?.id ?? null,
  city: contact.city || null,
  state: contact.state || null,
  country: contact.country || null,
  notes: contact.notes || null,
});
